var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('l-geo-json',{attrs:{"geojson":_vm.runs,"options-style":_vm.pathStyle},on:{"click":_vm.iriPathFeatureClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }